var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"title":_vm.$t('Subscribe to Creator'),"hide-footer":"","centered":"","body-class":"p-0","no-close-on-esc":"","no-fade":"","static":""},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('subscribe-creator-create')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }